import styled from 'styled-components'
import Palette from '@telus-uds/palette-allium/build/web/palette'

export const ArticleContainer = styled.div`
  display: block;
  cursor: pointer;
  & a {
    margin-bottom: 1.25rem;
  }
  & img {
    width: 100%;
    object-fit: cover;
  }
  & h3 {
    margin-bottom: 0.5rem;
  }
`
export const StyledCircle = styled.div`
  height: 5px;
  width: 5px;
  background-color: ${Palette.color.greyMystic};
  border-radius: 50%;
  margin: 3px 10px;
  display: inline-block;
`

export const DateAuthorRow = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-flow: row;
  align-items: baseline;
`

export const VideoContainer = styled.a`
  display: block;
  cursor: pointer;
  width: 100%;
  & #videoPlayerContainer {
    min-width: auto;
  }
  & .LazyLoad {
    width: 100%;
    height: 100%;
  }
`

export const ImageContainer = styled.a`
  display: block;
  cursor: pointer;
  width: 100%;
  & .LazyLoad {
    width: 100%;
    height: 100%;
  }
  & img {
    width: 100%;
    height: 286px;
    object-fit: cover;
  }
  &:hover {
    transform: scale(1.03);
    transition: all 0.3s ease-in-out 0s !important;
  }
`
